<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    chartData() {
      const { performance } = this.$store.state;

      const chartData = {
        labels: ['Successful', 'Pending', 'Failed'],
        datasets: [
          {
            label: 'Performance',
            data: performance,
            backgroundColor: [
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)',
              'rgb(255, 99, 132)',
            ],
            hoverOffset: 4,
          },
        ],
      };
      return chartData;
    },

    maximumValue() {
      return this.maxValue;
    },
  },

  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};

// https://stackoverflow.com/questions/63560472/update-vue-chartjs-yaxis-max-value-without-re-rendering-entire-vue-chart-js
// https://stackoverflow.com/questions/48312609/vuejs-chart-not-displaying-after-page-reload
// TODO: vue-chartjs only updates when the entire object in chartData is replaced
//
</script>
